<div class="flex flex-col gap-2">
    <div sag-ui-avatar-base>
        <div sag-ui-avatar>{{ user()?.firstName?.[0]?.toUpperCase() }}{{ user()?.lastName?.[0]?.toUpperCase() }}</div>
        <div>
            <div sag-ui-avatar-name>{{ user()?.firstName }} {{ user()?.lastName }}</div>
            <div sag-ui-avatar-org>{{ user()?.email }}</div>
        </div>
    </div>

    <!-- Comment box -->
    <div class="border border-shs-gray-3 rounded-md bg-transparent focus-within:border-shs-orange transition-colors">
        <sag-ui-textarea
            [placeholder]="'Add a comment...'"
            [formControl]="commentControl"
            (input)="handleInput($event)"
            class="border-0 !shadow-none"
        ></sag-ui-textarea>

        <!-- Pending attachments inside the box -->
        @if (pendingAttachments.length) {
        <div class="flex flex-wrap gap-2 px-3 pb-2">
            @for (attachment of pendingAttachments; track $index) {
            <div
                class="flex items-center gap-1 bg-shs-gray-4 rounded-full px-3 py-1 text-xs text-font-primary max-w-[200px]"
            >
                <span class="icon-attach text-shs-orange text-xs"></span>
                <span class="truncate">{{ attachment.name }}</span>
                <span
                    class="icon-close text-shs-gray-1 cursor-pointer hover:text-shs-red ml-1"
                    (click)="removePendingAttachment($index)"
                ></span>
            </div>
            }
        </div>
        }

        <!-- Toolbar row: attach icon left, submit button right -->
        <div class="flex items-center justify-between px-3 py-2 border-t border-shs-gray-4">
            <span
                class="icon-attach text-shs-gray-1 text-lg cursor-pointer hover:text-shs-orange transition-colors"
                title="Attach files"
                (click)="triggerFileInput()"
            ></span>
            <sag-ui-button [disabled]="!canSubmit" (click)="addComment()" size="sm">Add Comment</sag-ui-button>
        </div>
    </div>

    <!-- Hidden file input -->
    <input
        #fileInput
        type="file"
        multiple
        accept=".pdf,.ppt,.msg,.docx,.doc,.png,.jpg,.jpeg,.mpeg"
        class="hidden"
        (change)="handleFileSelect($event)"
    />
</div>

<div class="mt-4">
    <div class="flex flex-col gap-8 items-center" #table>
        @if (loading()) {
        <div class="flex flex-col gap-2 w-full">
            <div class="bg-shs-gray-4 rounded-md w-full h-14 animate-pulse"></div>
            <div class="bg-shs-gray-4 rounded-md w-full h-14 animate-pulse opacity-90"></div>
            <div class="bg-shs-gray-4 rounded-md w-full h-14 animate-pulse opacity-80"></div>
        </div>
        } @else { @if (comments().length === 0) {
        <div class="flex items-center justify-center min-h-[100px]">
            <p class="text-shs-gray-3">No comments</p>
        </div>
        } @else { @for (comment of comments(); track $index) {
        <div class="flex flex-col gap-2 w-full">
            <div class="flex justify-between items-center">
                <div sag-ui-avatar-base>
                    <div sag-ui-avatar class="!h-10 !w-10 text-sm">
                        {{ comment.user?.firstName?.[0]?.toUpperCase()}}{{ comment.user?.lastName?.[0]?.toUpperCase() }}
                    </div>
                    <div>
                        <div sag-ui-avatar-name>{{ comment.user?.firstName }} {{ comment.user?.lastName }}</div>
                        <div sag-ui-avatar-org>
                            {{ comment.user?.email
                            }}<span class="ml-4 text-shs-gray-1">{{
                                comment.createdAt | date : 'MMM d, yyyy HH:mm'
                            }}</span>
                        </div>
                    </div>
                </div>
                @if (user()?.gid === comment.createdBy) {
                <span
                    (click)="deleteComment(comment.id)"
                    class="icon-delete text-shs-red cursor-pointer hover:bg-red-500/20 p-1 rounded-full"
                    aria-label="Delete comment"
                ></span>
                }
            </div>
            <p class="text-shs-white-1 px-2">
                {{ comment.content }}
            </p>
            @if (comment.attachmentKeys?.length) {
            <div class="flex flex-wrap gap-2 px-2">
                @for (key of comment.attachmentKeys; track key) {
                <div
                    class="flex items-center gap-1 bg-shs-gray-4 rounded-full px-3 py-1 text-xs text-font-primary cursor-pointer hover:bg-shs-gray-3 transition-colors max-w-[200px]"
                    (click)="downloadAttachment(key)"
                    title="Download {{ getFileName(key) }}"
                >
                    <span class="icon-attach text-shs-orange text-xs"></span>
                    <span class="truncate">{{ getFileName(key) }}</span>
                </div>
                }
            </div>
            }
        </div>
        }}}
    </div>
</div>
